exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-69837249] {\n  max-height: 12rem;\n}\n", ""]);

// exports
